export const CHECKOUT_URLS = {
  primaria:
    'https://profelisto.com.ar/checkouts/cn/hWNCOhyoJzSq6dBeTx4HGyNm/es-ar?_r=AQABaxnU9FUfuaAO7mzHR2htwL6s6NIooWiM5yvUC5DLl1o',
  secundaria:
    'https://profelisto.com.ar/checkouts/cn/hWNCOhyzdZBKIAjM76lRuOhe/es-ar?_r=AQABVKLVnfljP64Rcfjkkd3XRVnbaFuNTyFnv2nFwLH_UTw',
  megapack:
    'https://profelisto.com.ar/checkouts/cn/hWNCOhzBVKgDpAhYB6KHpel8/es-ar?_r=AQABNTXtdquxiShioaJDtP1FRaM5NTYxAh9zAfAcE1HLRlg',
}
